import { isAccommodationItem, isExperienceItem } from 'lib/checkout/checkoutUtils'
import type { MachineContext } from 'typings/app/machineContext'

export type TripPlannerCartItemsData = MachineContext.CartItems

interface CartLinkedCandidate {
  productType: 'accommodation' | 'experience'
  cartItemId: string | undefined
}

const MISSING_CART_STATUSES: ReadonlySet<number> = new Set([403, 404])

function hasStatus(error: unknown, statuses: ReadonlySet<number>): boolean {
  if (!error || typeof error !== 'object') return false
  return 'status' in error && typeof error.status === 'number' && statuses.has(error.status)
}

export function isMissingTripPlannerCartError(error: unknown): boolean {
  return hasStatus(error, MISSING_CART_STATUSES)
}

export function mapTripPlannerCartItemsToMap(
  cartData: TripPlannerCartItemsData | undefined,
  multiCartId: string | undefined,
): Map<string, App.MultiCartItem> {
  if (!cartData || !multiCartId) return new Map<string, App.MultiCartItem>()
  const cartItems = cartData[multiCartId]
  if (!cartItems) return new Map<string, App.MultiCartItem>()
  return new Map(
    Object.values(cartItems)
      .filter(item => item.state !== 'deleted')
      .map(item => [item.id, item]),
  )
}

export function getTripPlannerCandidateCartItem(
  cartItemsMap: Map<string, App.MultiCartItem>,
  item: CartLinkedCandidate,
): App.MultiCartItem | undefined {
  const cartItem = item.cartItemId ? cartItemsMap.get(item.cartItemId) : undefined
  if (!cartItem) return undefined
  if (item.productType === 'accommodation') {
    return isAccommodationItem(cartItem.item) ? cartItem : undefined
  }
  return isExperienceItem(cartItem.item) ? cartItem : undefined
}
